import { RefObject, useEffect } from "react"

type UseKatexOptions = {
  enabled?: boolean
  contentKey?: unknown
}

/**
 * Lazily loads KaTeX and renders math in the element pointed to by `ref`.
 * Always runs both renderMathInElement and responsifyKatex.
 */
export function useKatex(
  ref: RefObject<Element | null>,
  { enabled = true, contentKey }: UseKatexOptions = {}
) {
  useEffect(() => {
    if (!enabled || !ref.current) return

    let cancelled = false

    import("./utils" /* webpackChunkName: "Katex" */).then(
      ({ renderMathInElement, responsifyKatex }) => {
        if (cancelled || !ref.current) return
        renderMathInElement(ref.current)
        responsifyKatex(ref.current)
      }
    )

    return () => {
      cancelled = true
    }
  }, [enabled, contentKey])
}
